import { RollupSnapshotStatus } from "containers/folders/types/server-rollups";

export const STATUS_TO_RECREATE_SNAPSHOT = [
    RollupSnapshotStatus.Stale,
    RollupSnapshotStatus.Expired,
    RollupSnapshotStatus.DeadlineExceeded,
];
